import axios from "axios";
import qs from "qs";
import { CONFIG } from "../../config";
import {
  BetTicketInfoPayload,
  PlaceBetTicketPayload,
  GetBetTicketPayload,
  GetReportTicketPayload,
} from "../../types/betTicket";
import {
  MIXED_PROVIDER_MESSAGE,
  normalizeProviderForComparison,
  isSabaComboDisabled,
  resolveProvider,
  SABA_COMBO_MESSAGE,
} from "../../utils/providerQuery";

class BetTicket {
  public getBetTickets = async (payload: GetBetTicketPayload) => {
    const result = await axios.post(
      `${CONFIG.API_URL}/c/m/runningList`,
      payload
    );

    return result?.data?.data;
  };

  public getReportTickets = async (payload: GetReportTicketPayload) => {
    const result = await axios.get(
      `${CONFIG.API_URL}/report/ticket?${qs.stringify(payload)}`
    );

    return result.data;
  };

  public placeBetTicket = async (payload: PlaceBetTicketPayload) => {
    const hasDisabledSabaCombo =
      payload.type === "comboStep" &&
      payload.matches.some((match) => {
        return isSabaComboDisabled(payload.pvd, match.sportType);
      });

    if (hasDisabledSabaCombo) {
      throw new Error(SABA_COMBO_MESSAGE);
    }

    const resolvedProviders = payload.matches.map((match) => {
      const provider = resolveProvider(payload.pvd, match.sportType);

      return normalizeProviderForComparison(provider);
    });
    const uniqueProviders = new Set(resolvedProviders);

    if (CONFIG.ENV === "production" && uniqueProviders.size > 1) {
      throw new Error(MIXED_PROVIDER_MESSAGE);
    }

    const firstMatch = payload.matches[0];
    const resolvedProvider = firstMatch
      ? resolveProvider(payload.pvd, firstMatch.sportType)
      : payload.pvd;
    const requestPayload = { ...payload };

    if (resolvedProvider !== payload.pvd) {
      requestPayload.pvd = resolvedProvider;
    }

    const result = await axios.post(
      `${CONFIG.API_URL}/c/m/sb/placeBet`,
      requestPayload,
    );

    return result?.data;
  };

  public getBetTicketInfo = async (payload: BetTicketInfoPayload) => {
    if (
      payload.type === "comboStep" &&
      isSabaComboDisabled(payload.pvd, payload.sportType)
    ) {
      throw new Error(SABA_COMBO_MESSAGE);
    }

    const { leagueId, ...payloadWithoutLeagueId } = payload;
    const resolvedProvider = resolveProvider(payload.pvd, payload.sportType);
    const requestPayload = {
      ...payloadWithoutLeagueId,
      matchId: `${leagueId}:${payload.matchId}`,
    };

    if (resolvedProvider !== payload.pvd) {
      requestPayload.pvd = resolvedProvider;
    }

    const result = await axios.post(
      `${CONFIG.API_URL}/c/m/sb/betInfo`,
      requestPayload,
    );

    return result?.data?.data;
  };
}

export default BetTicket;
